import { render, staticRenderFns } from "./GestionRecursos.vue?vue&type=template&id=ac5a7c62&scoped=true&lang=pug&"
import script from "./GestionRecursos.vue?vue&type=script&lang=js&"
export * from "./GestionRecursos.vue?vue&type=script&lang=js&"
import style0 from "./GestionRecursos.vue?vue&type=style&index=0&id=ac5a7c62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5a7c62",
  null
  
)

export default component.exports